import React from "react";
import Header1 from "../components/default-header";
import SidebarCustomer from "./sidebar_customer";
import CustomerFooter from "../components/CustomerFooter";

interface CustomerLayoutProps {
    children: React.ReactNode;
}

const CustomerLayout: React.FC<CustomerLayoutProps> = ({ children }) => {
    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=DM+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@500;600&display=swap');

                :root {
                    --p: #294b5a;
                    --p-dark: #1a313d;
                    --p-light: #3a6275;
                    --gold: #d3be76;
                    --gold-lt: #ede4b5;
                    --gold-dk: #b8a258;
                    --cream: #f7f5f1;
                    --muted: #7a8a91;
                    --white: #ffffff;
                    --sidebar-width: 280px; /* Largeur de la sidebar */
                }

                html, body { 
                    background: #f7f5f1; 
                    margin: 0;
                    padding: 0;
                    overflow-x: hidden;
                }

                .dashboard-customer {
                    font-family: 'DM Sans', sans-serif;
                    background: #f7f5f1;
                    min-height: 100vh;
                    width: 100%;
                }

                .va-mono { 
                    font-family: 'IBM Plex Mono', monospace; 
                }

                /* Sidebar inchangée selon la demande */
                .customer__sidebar {
                    position: fixed;
                    z-index: 100;
                    height: calc(100% - 90px);
                    padding-bottom: 40px;
                    will-change: transform;
                    transition: all 0.5s cubic-bezier(0.215, 0.61, 0.355, 1);
                    background: #f7f5f1;
                }
                
                .main-page {
                    display: flex;
                    padding: 16px 24px;
                    width: 100%;
                    box-sizing: border-box;
                }

                /* Classe renommée et corrigée */
                .customer__main {
                    flex: 1;
                    min-width: 0; /* Important: empêche Flexbox de déborder */
                    padding-left: var(--sidebar-width); /* Decale le contenu pour faire place à la sidebar fixed */
                    width: 100%;
                    box-sizing: border-box;
                    transition: all 0.5s cubic-bezier(0.215, 0.61, 0.355, 1);
                }

                .customer__content {
                    width: 100%;
                    box-sizing: border-box;
                }

                /* Responsive pour réduire le décalage sur petits écrans si la sidebar se masque */
                @media (max-width: 991px) {
                    .customer__main {
                        padding-left: 0;
                    }
                }
            `}</style>

            <div className="dashboard-customer">
                <div className="header-margin"></div>
                <Header1 />
                
                <div className="main-page">
                    <div className="customer__sidebar scroll-bar-1">
                        <SidebarCustomer />
                    </div>

                    {/* Renommé en customer__main */}
                    <div className="customer__main">
                        <div className="customer__content">
                            <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
                                <div className="col-12">
                                    {children}
                                </div>
                            </div>

                            <CustomerFooter />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CustomerLayout;